module.exports = __webpack_public_path__ + "images/花筑村全景_06-5.jpg?v=3d42c297";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_06-5.jpg
 ** module id = 97
 ** module chunks = 1 2
 **/